{
  "messages": {
    "maximumInSizeOnlyOneImageTextZipOrSpreadsheetAllowedToUploadMultipleDocsZipFirstThenUpload": "Ukuran maksimum {size}. Hanya {imageLimit}, {typeLimitText}, {typeLimitZip}, atau {typeLimitSpreadsheet} yang diperbolehkan. Untuk mengunggah beberapa dokumen, kompres ke zip terlebih dahulu lalu unggah.",
    "maximumInSizePerFileOnlyImageTextZipSpreadsheetAllowed": "Ukuran maksimum {size} per file. Maksimum {count} file. Hanya {image}, {text}, {zip}, atau {spreadsheet} yang diperbolehkan.",
    "oneImage": "SATU gambar",
    "sizeInMegabytes": "{size} MB",
    "uploadDocument": "Unggah dokumen",
    "uploadDocuments": "Unggah dokumen"
  }
}
